import React, { Component } from 'react'
import { css } from 'aphrodite'
import renderExtension from './renderExtension'
import styles from './styles'
import { connect } from '@cerebral/react'
import { props, state } from 'cerebral/tags'

export default connect(
  {
    thumbnail: state`${props`path`}.thumbnail`,
    name: state`${props`path`}.name`
  },
  class Thumbnail extends Component {
    renderThumbnail() {
      const { thumbnail, name } = this.props
      if (thumbnail) {
        return (
          <div
            className={css(styles.thumbnail)}
            style={{ backgroundImage: `url(${thumbnail})` }}
          />
        )
      }
      const View = renderExtension(name)
      return <View viewBox={'-3 -3 62 62'} />
    }

    render() {
      return (
        <div className={css(styles.thumbnailContainer)}>
          {this.renderThumbnail()}
        </div>
      )
    }
  }
)



// WEBPACK FOOTER //
// ./src/components/Media/File/Thumbnail/thumbnail.js